// Mock data for IMPERIA AI website

export const services = [
  {
    id: 1,
    title: "Social Media Marketing",
    description: "Vergroot je bereik en engagement met strategische social media campagnes op alle platforms.",
    icon: "Share2",
    features: ["Content creatie", "Community management", "Advertentie campagnes", "Analytics & rapportage"]
  },
  {
    id: 2,
    title: "SEO & Content Marketing",
    description: "Domineer de zoekresultaten met onze bewezen SEO strategieën en waardevolle content.",
    icon: "Search",
    features: ["Keyword research", "On-page optimalisatie", "Link building", "Blog & artikel creatie"]
  },
  {
    id: 3,
    title: "Google Ads / PPC",
    description: "Maximaliseer je ROI met gerichte betaalde advertentiecampagnes die converteren.",
    icon: "Target",
    features: ["Search campagnes", "Display advertenties", "Remarketing", "Conversie optimalisatie"]
  },
  {
    id: 4,
    title: "Branding & Design",
    description: "Creëer een onvergetelijke merkidentiteit die resoneert met je doelgroep.",
    icon: "Palette",
    features: ["Logo ontwerp", "Huisstijl ontwikkeling", "Brand guidelines", "Visuele identiteit"]
  },
  {
    id: 5,
    title: "Web Development",
    description: "Moderne, snelle en conversiegerichte websites die indruk maken.",
    icon: "Code",
    features: ["Responsive design", "E-commerce", "CMS integratie", "Performance optimalisatie"]
  },
  {
    id: 6,
    title: "Lead Generatie",
    description: "Genereer kwalitatieve leads die je salesteam kan converteren naar klanten.",
    icon: "Users",
    features: ["Landing pages", "Lead magnets", "Email funnels", "CRM integratie"]
  }
];

// Diverse Unsplash afbeeldingen per categorie
const seoImages = [
  "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1553484771-371a605b060b?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1557426272-fc759fdf7a8d?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1542744094-3a31f272c490?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1543286386-713bdd548da4?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1531973576160-7125cd663d86?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1573497620053-ea5300f94f21?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=600&h=400&fit=crop",
];

const socialImages = [
  "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1562577309-4932fdd64cd1?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1611605698335-8b1569810432?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1516251193007-45ef944ab0c6?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1556155092-490a1ba16284?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1600096194534-95cf5ece04cf?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1558403194-611308249627?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&h=400&fit=crop",
];

const adsImages = [
  "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1579621970795-87facc2f976d?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1553729459-efe14ef6055d?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1591696205602-2f950c417cb9?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1559526324-593bc073d938?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1444653614773-995cb1ef9efa?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1543286386-2e659306cd6c?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1579532537598-459ecdaf39cc?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1560472355-536de3962603?w=600&h=400&fit=crop",
];

const leadgenImages = [
  "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1556761175-4b46a572b786?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1553484771-371a605b060b?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1573497620053-ea5300f94f21?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1560264280-88b68371db39?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1552581234-26160f608093?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1531973576160-7125cd663d86?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1542744094-3a31f272c490?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop",
];

// Uitgebreide portfolio met 238 bedrijven
const seoCompanies = [
  "TechStart B.V.", "Bakkerij Van Dijk", "Advocatenkantoor Peters", "Makelaardij Zwolle", "Tandartspraktijk Smile",
  "Autobedrijf Jansen", "Accountantskantoor De Boer", "Installatiebedrijf Techniek Plus", "Bloemenwinkel Rosa", "Fysiotherapie Centrum Actief",
  "Bouwbedrijf Van der Berg", "Restaurant De Gouden Leeuw", "Schoonmaakbedrijf Blitz", "Kapsalon Luxe Hair", "Tuincentrum Groenrijk",
  "Sportschool FitLife", "Dierenarts Praktijk Vierpoten", "Elektricien Volt Elektra", "Notariskantoor Legaal", "Optiek Helder Zicht",
  "Schildersbedrijf Kleur", "Loodgieter Waterwerk", "Drukkerij PrintPro", "Fietsenmaker Wielrenner", "Juwelier Diamant",
  "Slagerij Vers Vlees", "Viswinkel Oceaan", "Apotheek Gezond", "Schoenenwinkel Stap", "Boekenwinkel Bladzijde",
  "Speelgoedwinkel Plezier", "Sportwinkel Actief", "Meubel Outlet Wonen", "Elektronicawinkel Tech", "Bouwmarkt Klus",
  "Autogarage Snelservice", "Taxibedrijf Direct", "Catering Service Smaak", "Schoonheidssalon Glow", "Nagelstudio Shine",
  "Massagepraktijk Relax", "Yogastudio Balans", "Muziekschool Melodie", "Rijschool Rijklaar", "Talenschool Polyglot",
  "Kinderopvang Blije Kids", "Huisartsenpraktijk Gezond", "Psycholoog Praktijk Mind", "Diëtist Voeding", "Osteopaat Beweging",
  "Logopedist Spraak", "Verloskundige Praktijk", "Orthodontist Smile Plus", "Plastisch Chirurg Beauty", "Dermatoloog Huid",
  "Oogarts Zicht", "KNO Arts Gehoor", "Cardioloog Hart", "Neuroloog Brein", "Uroloog Care"
];

const socialCompanies = [
  "FreshFood Nederland", "Mode Boutique Chique", "Fitness Guru Online", "Reisburo Fernweh", "Beauty Brand Glow",
  "Auto Dealer Premium Cars", "Restaurant Groep Smaak", "Woninginrichting Stijl", "Tech Gadgets Shop", "Huisdieren Winkel PetLove",
  "Bakkerij Ambacht", "Sportmerk ActiveWear", "Wijnhandel Druif", "Bruidsmodewinkel Dreams", "Kinderkleding Mini Style",
  "Hoveniersbedrijf Groen", "Apotheek Gezondheid Plus", "Fietsenwinkel Pedaal", "Yoga Studio Zen", "Meubelmaker Hout & Design",
  "Koffie Brand Barista", "Thee Importeur Orient", "Chocolatier Sweet", "IJssalon Gelato", "Patisserie Zoet",
  "Wijn & Spirits Import", "Craft Beer Brouwerij", "Cocktailbar Shaker", "Sushi Restaurant Nippon", "Steakhouse Prime",
  "Vegan Restaurant Green", "Pizzeria Napoli", "Burger Joint Grill", "Mexican Food Casa", "Thai Kitchen Bangkok",
  "Indian Cuisine Spice", "Chinese Restaurant Dragon", "Greek Taverna Olive", "French Bistro Paris", "Spanish Tapas Barcelona",
  "Food Truck Festival", "Pop-up Restaurant", "Cooking School Chef", "Wine Tasting Events", "Food Photography Studio",
  "Recipe Blog Foodie", "Nutrition Coach Fit", "Meal Prep Service", "Organic Farm Fresh", "Farmers Market Local",
  "Delicatessen Gourmet", "Cheese Shop Kaas", "Butcher Shop Prime", "Fish Market Verse", "Bakery Fresh Daily",
  "Coffee Roasters Bean", "Tea House Leaf", "Smoothie Bar Blend", "Juice Press Fresh", "Health Food Store"
];

const adsCompanies = [
  "LuxeWonen.nl", "Zonnepanelen Direct", "Webshop Electronics Plus", "Dakdekker Firma Top", "Rijschool Snel Rijbewijs",
  "Airco Specialist Cool", "Slotenmaker 24/7", "Verhuisbedrijf Flexibel", "CV Ketel Expert", "Glashandel Helder",
  "Online Apotheek MedCare", "Keukencentrum Design", "Badkamer Specialist", "Tuinhuis Expert", "Verzekeringen Vergelijk",
  "Autoverhuur Budget", "Banden Online Shop", "Kozijnen & Deuren", "Hypotheek Adviseur Plus", "Trouwlocatie Finder",
  "Isolatie Bedrijf Warm", "Vloeren Specialist", "Gordijnen Atelier", "Zonwering Expert", "Alarm Systemen Safe",
  "Slimme Thermostaat", "Zonneboiler Direct", "Warmtepomp Dealer", "Elektrische Auto Lease", "Scooter Shop City",
  "E-bike Centrum", "Motor Dealer Speed", "Camper Verhuur Travel", "Boot Verkoop Marine", "Caravan Center",
  "Vakantiehuizen Booking", "Hotelketen Stars", "B&B Collectie", "Appartement Verhuur", "Studentenkamers",
  "Kantoorruimte Verhuur", "Bedrijfspand Makelaars", "Industrieterrein Park", "Winkelcentrum Mall", "Parkeergarage City",
  "Opslag Units Box", "Verhuislift Service", "Container Verhuur", "Steiger Verhuur", "Gereedschap Huur",
  "Machine Verhuur Pro", "Aggregaat Verhuur", "Compressor Verhuur", "Generator Lease", "Bouwkraan Verhuur",
  "Hoogwerker Huren", "Graafmachine Verhuur", "Shovel Rental", "Roller Verhuur", "Asfalteermachine"
];

const leadgenCompanies = [
  "GreenEnergy Solutions", "WeOwnIt CC", "TempTeam AS", "CityCall CC", "Imperium CC",
  "DirectCall Solutions", "ContactCenter Pro", "PhoneFirst CC", "CallForce Nederland", "ServiceLine CC",
  "Solar Direct Nederland", "Isolatie Experts", "Energievergelijker Plus", "Hypotheekshop Regio", "Autolease Direct",
  "Recruitment Bureau TopTalent", "Verzekering Advies Groep", "Warmtepomp Specialist", "Dakkapel Direct", "Zorgverzekering Vergelijker",
  "ConnectCall CC", "ProCall Services", "VoiceNL CC", "TeleConnect Nederland", "CallDirect Services",
  "LeadGen Masters", "Conversion Kings", "Sales Funnel Pro", "Pipeline Builders", "Prospect Hunter",
  "B2B Connect", "Enterprise Leads", "SMB Solutions", "Startup Growth", "Scale Up Partners",
  "Dutch Call Center", "Holland Contact", "Amsterdam CC", "Rotterdam Call", "Utrecht Connect",
  "Eindhoven Services", "Groningen Call", "Maastricht CC", "Breda Contact", "Tilburg Services",
  "Arnhem Call Center", "Nijmegen Connect", "Enschede CC", "Almere Services", "Haarlem Call",
  "Amersfoort CC", "Den Bosch Contact", "Leiden Services", "Dordrecht Call", "Zoetermeer CC",
  "Haarlemmermeer Contact", "Zwolle Services", "Apeldoorn Call"
];

const seoResults = ["+340% organisch verkeer", "+280% lokaal verkeer", "+420% organisch verkeer", "+310% leads", "+250% nieuwe klanten", "+380% zoekverkeer", "+290% B2B leads", "+360% offertes", "+220% online bestellingen", "+340% afspraken", "+410% projectaanvragen", "+270% reserveringen", "+320% klantaanvragen", "+280% boekingen", "+350% webshop verkeer", "+290% nieuwe leden", "+260% nieuwe klanten", "+380% servicecalls", "+310% contactaanvragen", "+240% afspraken"];
const socialResults = ["50K+ nieuwe volgers", "75K+ volgers", "120K+ volgers", "45K+ volgers", "90K+ volgers", "35K+ volgers", "60K+ volgers", "55K+ volgers", "80K+ volgers", "65K+ volgers", "40K+ volgers", "95K+ volgers", "30K+ volgers", "45K+ volgers", "70K+ volgers", "25K+ volgers", "35K+ volgers", "40K+ volgers", "55K+ volgers", "30K+ volgers"];
const adsResults = ["€2.4M extra omzet", "€1.8M omzet", "€3.2M omzet", "€890K omzet", "€650K omzet", "€720K omzet", "€480K omzet", "€1.1M omzet", "€950K omzet", "€580K omzet", "€2.1M omzet", "€1.5M omzet", "€1.3M omzet", "€780K omzet", "€2.8M omzet", "€920K omzet", "€1.4M omzet", "€1.1M omzet", "€3.5M in leads", "€680K omzet"];
const leadgenResults = ["1200+ leads/maand", "2500+ leads/maand", "1800+ leads/maand", "3200+ leads/maand", "2800+ leads/maand", "1900+ leads/maand", "2200+ leads/maand", "1600+ leads/maand", "2400+ leads/maand", "1500+ leads/maand", "850+ leads/maand", "920+ leads/maand", "1400+ leads/maand", "680+ leads/maand", "750+ leads/maand", "540+ leads/maand", "890+ leads/maand", "620+ leads/maand", "480+ leads/maand", "1100+ leads/maand"];

const seoDescriptions = ["Complete SEO-strategie", "Lokale SEO optimalisatie", "Content marketing strategie", "B2B SEO campagne", "E-commerce SEO", "Technische SEO audit", "Link building campagne", "Keyword optimalisatie", "On-page SEO", "Off-page SEO strategie"];
const socialDescriptions = ["Social media strategie", "Instagram growth campagne", "LinkedIn B2B marketing", "TikTok viral content", "Facebook community building", "YouTube channel growth", "Pinterest marketing", "Twitter engagement", "Influencer marketing", "UGC campagne"];
const adsDescriptions = ["Google Ads campagne", "Shopping ads strategie", "Display remarketing", "Search campagne", "Performance Max", "YouTube ads", "Discovery ads", "Local services ads", "App campagne", "Smart bidding strategie"];
const leadgenDescriptions = ["B2B lead generatie", "Callcenter acquisitie", "Telemarketing campagne", "Outbound sales", "Lead nurturing", "Email marketing funnel", "Landing page optimalisatie", "Conversion rate optimalisatie", "Sales funnel", "Pipeline development"];

// Generate 238 portfolio cases
export const portfolioCases = [];
let id = 1;

// SEO & Content - 60 bedrijven
seoCompanies.forEach((company, index) => {
  portfolioCases.push({
    id: id++,
    title: company,
    category: "SEO & Content",
    result: seoResults[index % seoResults.length],
    description: seoDescriptions[index % seoDescriptions.length] + " voor " + company.toLowerCase(),
    image: seoImages[index % seoImages.length]
  });
});

// Social Media - 60 bedrijven
socialCompanies.forEach((company, index) => {
  portfolioCases.push({
    id: id++,
    title: company,
    category: "Social Media",
    result: socialResults[index % socialResults.length],
    description: socialDescriptions[index % socialDescriptions.length] + " voor " + company.toLowerCase(),
    image: socialImages[index % socialImages.length]
  });
});

// Google Ads - 58 bedrijven
adsCompanies.forEach((company, index) => {
  portfolioCases.push({
    id: id++,
    title: company,
    category: "Google Ads",
    result: adsResults[index % adsResults.length],
    description: adsDescriptions[index % adsDescriptions.length] + " voor " + company.toLowerCase(),
    image: adsImages[index % adsImages.length]
  });
});

// Lead Generatie - 60 bedrijven
leadgenCompanies.forEach((company, index) => {
  portfolioCases.push({
    id: id++,
    title: company,
    category: "Lead Generatie",
    result: leadgenResults[index % leadgenResults.length],
    description: leadgenDescriptions[index % leadgenDescriptions.length] + " voor " + company.toLowerCase(),
    image: leadgenImages[index % leadgenImages.length]
  });
});

export const testimonials = [
  {
    id: 1,
    name: "Thomas van der Berg",
    role: "CEO, TechStart B.V.",
    content: "IMPERIA AI heeft onze online aanwezigheid compleet getransformeerd. Hun strategische aanpak en data-gedreven beslissingen hebben ons 340% meer organisch verkeer opgeleverd.",
    avatar: "TB"
  },
  {
    id: 2,
    name: "Lisa de Groot",
    role: "Marketing Director, FreshFood",
    content: "De creativiteit en professionaliteit van het IMPERIA AI team is ongeëvenaard. Ze begrijpen écht wat werkt op social media en leveren consistente resultaten.",
    avatar: "LG"
  },
  {
    id: 3,
    name: "Mark Jansen",
    role: "Eigenaar, LuxeWonen.nl",
    content: "Onze Google Ads campagnes presteren nu 3x beter dan voorheen. De ROI die we met IMPERIA AI hebben behaald is fenomenaal. Absolute aanrader!",
    avatar: "MJ"
  },
  {
    id: 4,
    name: "Sandra Bakker",
    role: "Operations Manager, WeOwnIt CC",
    content: "IMPERIA AI levert consistent kwalitatieve leads voor ons callcenter. De conversieratio's zijn uitstekend en de samenwerking is zeer professioneel.",
    avatar: "SB"
  },
  {
    id: 5,
    name: "Erik Visser",
    role: "Directeur, CityCall CC",
    content: "Dankzij IMPERIA AI zijn we van 500 naar 3200+ leads per maand gegaan. Hun lead generatie strategie is precies wat we nodig hadden voor onze groei.",
    avatar: "EV"
  }
];

export const pricingPackages = [
  {
    id: 1,
    name: "Starter",
    price: "999",
    period: "per maand",
    description: "Perfect voor kleine bedrijven die willen groeien",
    features: [
      "Social media beheer (2 platforms)",
      "4 posts per week",
      "Basis SEO optimalisatie",
      "Maandelijkse rapportage",
      "Email support"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Professional",
    price: "2.499",
    period: "per maand",
    description: "Voor bedrijven die serieus willen opschalen",
    features: [
      "Social media beheer (4 platforms)",
      "Dagelijkse posts",
      "Uitgebreide SEO strategie",
      "Google Ads campagne",
      "Content creatie",
      "Wekelijkse rapportage",
      "Dedicated account manager"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Enterprise",
    price: "4.999",
    period: "per maand",
    description: "Complete marketing oplossing voor grote organisaties",
    features: [
      "Alle Professional features",
      "Onbeperkte platforms",
      "Video content productie",
      "Influencer marketing",
      "Lead generatie systeem",
      "24/7 prioriteit support",
      "Strategie sessies"
    ],
    popular: false
  }
];

export const vacatures = [
  {
    id: 1,
    title: "Senior Social Media Manager",
    type: "Fulltime",
    location: "Zwolle / Hybrid",
    salary: "€3.500 - €4.500",
    description: "We zoeken een ervaren Social Media Manager die onze klanten helpt groeien op alle social platforms. Je bent verantwoordelijk voor het ontwikkelen en uitvoeren van social media strategieën voor diverse klanten.",
    responsibilities: [
      "Ontwikkelen van social media strategieën voor B2B en B2C klanten",
      "Aansturen van content creators en designers",
      "Analyseren van campagne resultaten en optimaliseren",
      "Klantcontact en presentaties geven",
      "Bijhouden van de laatste social media trends"
    ],
    requirements: [
      "Minimaal 3 jaar ervaring in social media marketing",
      "Aantoonbare resultaten met social media campagnes",
      "Uitstekende communicatieve vaardigheden (Nederlands en Engels)",
      "Ervaring met tools zoals Hootsuite, Buffer, Meta Business Suite",
      "HBO werk- en denkniveau"
    ],
    benefits: [
      "Competitief salaris + bonus",
      "Hybride werken (2 dagen thuis)",
      "Laptop en telefoon",
      "Opleidingsbudget €1.500/jaar",
      "Pensioenregeling"
    ]
  },
  {
    id: 2,
    title: "SEO Specialist",
    type: "Fulltime",
    location: "Zwolle / Hybrid",
    salary: "€3.000 - €4.200",
    description: "Ben jij een data-gedreven SEO expert? Help onze klanten domineren in de zoekresultaten met technische SEO, content optimalisatie en link building strategieën.",
    responsibilities: [
      "Uitvoeren van technische SEO audits",
      "Keyword research en content strategie ontwikkelen",
      "On-page en off-page optimalisatie",
      "Link building campagnes opzetten en uitvoeren",
      "Rapporteren over rankings en organisch verkeer"
    ],
    requirements: [
      "Minimaal 2 jaar ervaring in SEO",
      "Kennis van tools zoals Ahrefs, SEMrush, Screaming Frog",
      "Ervaring met Google Analytics en Search Console",
      "Technische achtergrond is een plus",
      "Analytisch sterk en resultaatgericht"
    ],
    benefits: [
      "Competitief salaris",
      "Hybride werken",
      "SEO tool licenties",
      "Conferentie budget",
      "Vrijdagmiddagborrel"
    ]
  },
  {
    id: 3,
    title: "Content Creator / Copywriter",
    type: "Fulltime / Parttime",
    location: "Zwolle / Remote",
    salary: "€2.800 - €3.800",
    description: "Schrijf je graag pakkende content? Word onderdeel van ons content team en creëer overtuigende teksten voor websites, social media, advertenties en email campagnes.",
    responsibilities: [
      "Schrijven van website content en landingspagina's",
      "Creëren van social media posts en captions",
      "Ontwikkelen van email marketing content",
      "Schrijven van blog artikelen en whitepapers",
      "Advertentieteksten voor Google en Meta"
    ],
    requirements: [
      "Uitstekende schrijfvaardigheid in Nederlands",
      "Ervaring met SEO-vriendelijk schrijven",
      "Creatief en kan verschillende tone-of-voices aan",
      "Portfolio met schrijfvoorbeelden",
      "MBO4+ opleiding in communicatie of marketing"
    ],
    benefits: [
      "Flexibele werktijden",
      "Volledig remote mogelijk",
      "Creatieve vrijheid",
      "Schrijfworkshops",
      "Gezellig team"
    ]
  },
  {
    id: 4,
    title: "Google Ads Specialist",
    type: "Fulltime",
    location: "Zwolle / Hybrid",
    salary: "€3.200 - €4.500",
    description: "Wij zoeken een Google Ads expert die verantwoordelijk wordt voor het opzetten, optimaliseren en schalen van PPC campagnes voor onze diverse klantenbasis.",
    responsibilities: [
      "Opzetten van Search, Display en Shopping campagnes",
      "Dagelijkse optimalisatie en bid management",
      "A/B testen van advertenties en landingspagina's",
      "Conversie tracking implementeren",
      "Budget management en forecasting"
    ],
    requirements: [
      "Google Ads gecertificeerd",
      "Minimaal 2 jaar ervaring met Google Ads",
      "Ervaring met grote budgetten (€50K+/maand)",
      "Kennis van Google Analytics 4",
      "Excel/data analyse skills"
    ],
    benefits: [
      "Certificering budget",
      "Bonus bij target behalen",
      "Werken met grote merken",
      "Carrière groeipad",
      "Team events"
    ]
  },
  {
    id: 5,
    title: "Junior Marketing Medewerker",
    type: "Fulltime",
    location: "Zwolle",
    salary: "€2.200 - €2.800",
    description: "Start je carrière in digital marketing bij een dynamisch en groeiend bureau. Je leert alle facetten van online marketing en krijgt begeleiding van ervaren professionals.",
    responsibilities: [
      "Assisteren bij social media beheer",
      "Content uploaden en plannen",
      "Basis data analyse en rapportages",
      "Ondersteunen bij campagne uitvoering",
      "Administratieve marketing taken"
    ],
    requirements: [
      "Recent afgestudeerd (HBO Marketing/Communicatie)",
      "Passie voor digital marketing",
      "Leergierig en proactief",
      "Goede beheersing van Nederlands en Engels",
      "Bekend met social media platforms"
    ],
    benefits: [
      "Uitgebreid traineeship programma",
      "Mentorship van seniors",
      "Snelle doorgroeimogelijkheden",
      "Jong en dynamisch team",
      "Gezellige werksfeer"
    ]
  },
  {
    id: 6,
    title: "Lead Generation Specialist",
    type: "Fulltime",
    location: "Zwolle / Hybrid",
    salary: "€3.000 - €4.000",
    description: "Word verantwoordelijk voor het genereren van kwalitatieve leads voor onze klanten. Je zet complete lead funnels op en optimaliseert deze voor maximale conversie.",
    responsibilities: [
      "Ontwikkelen van lead generatie strategieën",
      "Bouwen van landing pages en funnels",
      "Email marketing automation opzetten",
      "Lead scoring en nurturing implementeren",
      "CRM integraties beheren"
    ],
    requirements: [
      "Ervaring met lead generatie campagnes",
      "Kennis van marketing automation tools",
      "Ervaring met landing page builders",
      "Data-gedreven mindset",
      "B2B marketing ervaring is een plus"
    ],
    benefits: [
      "Performance bonus",
      "Tool stack naar keuze",
      "Hybride werken",
      "Innovatieve projecten",
      "Marktconform salaris"
    ]
  },
  {
    id: 7,
    title: "Account Manager",
    type: "Fulltime",
    location: "Zwolle",
    salary: "€3.500 - €5.000 + bonus",
    description: "Als Account Manager ben je het eerste aanspreekpunt voor onze klanten. Je bouwt sterke relaties, identificeert groeikansen en zorgt voor tevreden klanten.",
    responsibilities: [
      "Beheren van klantrelaties en verwachtingen",
      "Upselling en cross-selling van diensten",
      "Coördineren tussen klant en interne teams",
      "Presenteren van resultaten en strategieën",
      "Klachtenafhandeling en service recovery"
    ],
    requirements: [
      "Minimaal 3 jaar ervaring in account management",
      "Commerciële instelling en targets gedreven",
      "Uitstekende presentatie vaardigheden",
      "Kennis van digital marketing is een must",
      "Rijbewijs B (klantbezoeken)"
    ],
    benefits: [
      "Aantrekkelijke bonusstructuur",
      "Leaseauto",
      "Telefoon vergoeding",
      "Representatie budget",
      "Doorgroeimogelijkheden naar management"
    ]
  },
  {
    id: 8,
    title: "Video Content Creator",
    type: "Fulltime / Parttime",
    location: "Zwolle / Hybrid",
    salary: "€2.800 - €3.800",
    description: "Creëer impactvolle video content voor social media, websites en advertenties. Van concept tot eindproduct, jij maakt video's die resultaat opleveren.",
    responsibilities: [
      "Produceren van social media video's (Reels, TikToks, Stories)",
      "Filmen en editen van klantvideo's",
      "Ontwikkelen van video concepten en scripts",
      "Motion graphics en animaties maken",
      "Beheren van video equipment"
    ],
    requirements: [
      "Ervaring met video editing (Premiere Pro, Final Cut)",
      "Kennis van After Effects is een plus",
      "Eigen camera equipment is een pre",
      "Creatief en trendbewust",
      "Portfolio met video werk"
    ],
    benefits: [
      "Creatieve vrijheid",
      "Toegang tot professionele equipment",
      "Adobe Creative Cloud licentie",
      "Flexibele werkuren",
      "Leuke shoot dagen"
    ]
  },
  {
    id: 9,
    title: "Marketing Stagiair",
    type: "Stage (4-6 maanden)",
    location: "Zwolle",
    salary: "€500 - €600 stagevergoeding",
    description: "Leer alle ins en outs van digital marketing tijdens een uitdagende stage. Je draait volledig mee in het team en werkt aan echte klantprojecten.",
    responsibilities: [
      "Assisteren bij diverse marketing projecten",
      "Social media content creatie",
      "Onderzoek en analyse taken",
      "Meewerken aan campagnes",
      "Eigen project uitvoeren"
    ],
    requirements: [
      "HBO student Marketing, Communicatie of aanverwant",
      "Beschikbaar voor minimaal 4 maanden",
      "Enthousiast en leergierig",
      "Goede beheersing MS Office",
      "Affiniteit met social media"
    ],
    benefits: [
      "Waardevolle werkervaring",
      "Begeleiding door professionals",
      "Kans op vast contract",
      "Lunch verzorgd",
      "Reiskostenvergoeding"
    ]
  },
  {
    id: 10,
    title: "Performance Marketing Manager",
    type: "Fulltime",
    location: "Zwolle / Hybrid",
    salary: "€4.000 - €5.500",
    description: "Leid ons performance marketing team en wees verantwoordelijk voor alle paid media campagnes. Je stuurt een team aan en rapporteert direct aan de directie.",
    responsibilities: [
      "Aansturen van het performance team (3-4 personen)",
      "Strategische planning voor paid media",
      "Budget allocatie over kanalen",
      "Klantpresentaties op directieniveau",
      "Innovatie en nieuwe kanalen testen"
    ],
    requirements: [
      "Minimaal 5 jaar ervaring in performance marketing",
      "Leidinggevende ervaring",
      "Expert in Google Ads en Meta Ads",
      "Strategisch en analytisch sterk",
      "Ervaring met 7-figure budgetten"
    ],
    benefits: [
      "Leidinggevende rol",
      "Aantrekkelijk salaris + bonus",
      "Auto van de zaak",
      "Management trainingen",
      "Invloed op bedrijfsstrategie"
    ]
  }
];

export const stats = [
  { value: "238+", label: "Tevreden klanten" },
  { value: "€18M+", label: "Gegenereerde omzet" },
  { value: "95%", label: "Klantretentie" },
  { value: "8+", label: "Jaar ervaring" }
];

export const contactInfo = {
  email: "info@imperiaai.nl",
  phone: "0382340037",
  address: "Paxtonstraat 3n, 8013RP Zwolle"
};
